import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import Chevron from '../../../assets/icons/chevron_bottom.svg';
import ModalType from '../../../models/ModalType';

import { useModal } from '../../../context/ModalContext';

import './faqSection.scss';

export default function FaqSection(props) {
  const { questions } = props;

  const { openModal } = useModal();

  useEffect(() => {
    const addModalLinkClickEvent = (selector, popupName, fn) => {
      document.querySelectorAll(selector).forEach((link) => {
        link.addEventListener('click', () => {
          fn();
          if (window.posthog) window.posthog.capture('open_popup', { popup_name: popupName });
        });
      });
    };

    addModalLinkClickEvent('.check-eligibility-link', 'check-eligibility', () => openModal(ModalType.CHECK_ELIGIBILITY));
    addModalLinkClickEvent('.prices-link', 'price', () => openModal(ModalType.PRICES));
  }, []);

  return (
    <section id="faq" className="faq">
      <div className="content">
        <div className="title-container">
          <h2>
            Top&nbsp;
            <span className="salmon">questions</span>
          </h2>
          <h6>
            Visit our full
            {' '}
            <a href="/faq">FAQ page</a>
            {' '}
            for more asked questions
          </h6>
        </div>

        <div className="questions-container">
          {questions.map((question) => (
            <div className="question-container">
              <button
                className="button-unset title-wrapper"
                type="button"
                onClick={(e) => e.currentTarget.closest('.question-container').classList.toggle('active')}
              >
                <h6>{question.title}</h6>
                <Chevron width="24px" height="24px" />
              </button>

              <div className="answer-wrapper">
                <div className="answer-content">
                  {parse(question.content)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

FaqSection.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  })).isRequired,
};
